import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ToolStatusHistory } from 'app/shared/models/tool-status-history.model';
import { ToolLifecycleHistory } from '@models/tool-lifecycle-history.model';

import { TableConfig } from '@app/shared/util/table-config.utils';

import { AppUtils } from '@app/shared/util/app.utils';

import { PagedResponse } from '@models/response.model';

import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable()
export class ToolHistoryService {

    static readonly STATUS_HISTORY_API_GET_PATH = `${environment.baseURL}/api/tools/history/status`;
    static readonly STATUS_HISTORY_API_DOWNLOAD_PATH = `${environment.baseURL}/api/tools/history/status/download`;

    static readonly LIFECYCLE_HISTORY_API_GET_PATH = `${environment.baseURL}/api/tools/history/lifecycle`;
    static readonly LIFECYCLE_HISTORY_API_DOWNLOAD_PATH = `${environment.baseURL}/api/tools/history/lifecycle/download`;

    constructor(private http: HttpClient) {
    }

    getStatusHistory(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<ToolStatusHistory>>(ToolHistoryService.STATUS_HISTORY_API_GET_PATH,
            {params: params}).pipe(map(this.mapStatusHistory));
    }

    private mapStatusHistory = res => {
        return {
            toolStatusHistory: res.items.map(toolStatusHistory => new ToolStatusHistory(toolStatusHistory)),
            count: res.total
        };
    };

    downloadStatusHistoryReport(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(ToolHistoryService.STATUS_HISTORY_API_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }

    getLifecycleHistory(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<ToolLifecycleHistory>>(ToolHistoryService.LIFECYCLE_HISTORY_API_GET_PATH,
            {params: params}).pipe(map(this.mapLifecycleHistory));
    }

    private mapLifecycleHistory = res => {
        return {
            toolLifecycleHistory: res.items.map(toolLifecycleHistory => new ToolLifecycleHistory(toolLifecycleHistory)),
            count: res.total
        };
    };

    downloadLifecycleHistoryReport(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(ToolHistoryService.LIFECYCLE_HISTORY_API_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }

}
